import { Component, Fragment } from 'react';

import { Star as StarIcon } from '@mui/icons-material';
import { Box, Button, Divider, Grid, Rating } from '@mui/material';
import _, { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

import acl from 'constants/acl';
import AxlDialog from '../AxlDialog';
import DriverProfileInformation from '../DriverProfileInformation';
import DriverProfileRoutingTabs from '../DriverProfileRoutingTabs';
import ReasonDialog from '../ReasonDialog';
import styles from './styles';

class DriverInfoCardCompose extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: '',
      showInfo: false,
      showDriverPicture: false,
      showUnassignDriver: false,
      showDriverProfile: false,
      showDriverDialog: false,
    };
  }

  onShowDriverDialog = () => {
    this.setState({ showDriverDialog: true });
  };

  onHideDriverDialog = () => {
    this.setState({ showDriverDialog: false });
  };

  showUnassignDriver = () => {
    this.setState({ showUnassignDriver: true });
  };

  hideUnassignDriver = () => {
    this.setState({ showUnassignDriver: false, reason: '' });
  };

  confirmUnassignDriver = () => {
    const { reason } = this.state;
    // if (!reason) return;

    this.props.onUnAssignDriver(reason);
  };

  reassign = () => {
    this.hideUnassignDriver();
    this.props.showDriverAssign();
  };

  onShowDriverProfile = () => {
    if (this.props.driver) {
      this.setState({ showDriverProfile: true });
    }
  };

  onHideDriverProfile = () => {
    this.setState({ showDriverProfile: false });
  };

  // todo: Show driver profile modal
  render() {
    const { showUnassignDriver, reason, showInfo } = this.state;
    const { driver, driverScore, isActivated, isCompleted, store } = this.props;
    const { assignmentStore, permissionStore } = store;

    const { unAssigning, loadingAssignment } = assignmentStore;
    const assigmentLabel = _.get(this, 'props.assignment.assignment.label', 'N/A');
    const canUnassign = driver && !isActivated && !isCompleted;
    const driverData = driver
      ? {
          ...driver,
          driverScore: this.props.driverScore ? this.props.driverScore : 0,
        }
      : {
          fake: true,
          first_name: '',
          last_name: '',
          status: '-',
          driverScore: 0,
          phone_number: '-',
          driver_license: '-',
          ssn_verified_by: '-',
          vehicle_make: '-',
          vehicle_model: '-',
          vehicle_color: '-',
          vehicle_license_plate: '-',
          background_decision_ts: '-',
          vehicle_license_plate_state: '-',
        };
    const driverDataMap = [
      { label: 'Phone', key: 'phone_number', isDate: false },
      { label: 'Status', key: 'status', isDate: false },
      { label: 'JID', key: 'id', isDate: false },
      { label: 'Joined', key: 'background_decision_ts', isDate: true },
      { label: 'D/L No.', key: 'driver_license', isDate: false },
    ];

    const isDeniedAssignDriver = permissionStore.isDenied(acl.ASSIGNMENTS.ASSIGN);

    return (
      <Box sx={styles.container} p={1}>
        <Grid container alignItems="center" justifyContent="space-between" style={{ marginBottom: 10 }}>
          <Grid>
            <Box component="span" sx={styles.label2}>Driver Info:</Box>
          </Grid>
          {!isDeniedAssignDriver && (
            <Grid>
              {canUnassign && (
                <Fragment>
                  <Button
                    variant="outlined"
                    size="small"
                    disableElevation
                    onClick={this.showUnassignDriver}
                    disabled={driver && (isActivated || isCompleted)}
                    sx={{ mr: 1 }}
                  >
                    Unassign Driver
                  </Button>

                  <Button variant="outlined" size="small" disableElevation onClick={this.reassign}>
                    Reassign
                  </Button>
                </Fragment>
              )}
              {!canUnassign && (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  disableElevation
                  onClick={this.reassign}
                  disabled={driver && (isActivated || isCompleted)}
                >
                  {!driver ? 'Assign' : 'Unassign'}
                </Button>
              )}
            </Grid>
          )}
        </Grid>
        <Grid container spacing={2}>
          <Grid sx={styles.driverInfoLeft}>
            <Box sx={styles.driverPhotoContainer}>
              {_.has(driverData, 'id') && (
                <>
                  <Box sx={styles.photo} onClick={this.onShowDriverDialog} style={{ cursor: 'pointer' }}>
                    {_.has(driverData, 'photo') ? (
                      <img alt="" src={driverData.photo} style={styles.driverPhoto} />
                    ) : (
                      <Box sx={styles.defaultDriverPhoto} />
                    )}
                  </Box>
                  <AxlDialog
                    isOpen={this.state.showDriverDialog}
                    handleClose={this.onHideDriverDialog}
                    childrenTitle="Driver Profile"
                    maxWidth="lg"
                  >
                    <DriverProfileInformation driver={driverData} />
                    <DriverProfileRoutingTabs driver={driverData} onSave={this.onHideDriverDialog} history={this.props.history} isShowAction={false} />
                  </AxlDialog>
                </>
              )}
            </Box>
          </Grid>
          <Grid sx={styles.driverInfoRight}>
            <Fragment>
              <Box sx={styles.driverName}>
                {driverData.first_name} {driverData.last_name}
              </Box>
              <Rating
                size="small"
                name="driver-score"
                emptyIcon={<StarIcon color="inherit" fontSize="inherit" />}
                icon={<StarIcon color="primary" fontSize="inherit" />}
                readOnly
                value={driverScore ?? 0}
              />
              <Grid container spacing={1}>
                {driverDataMap.map((field) => (
                  <Grid size={6} key={`driver-info-${field.key}`}>
                    <Box sx={styles.itemWrapper}>
                      <Box component="span" sx={styles.label}>
                        {field.label}
                      </Box>
                      <Box component="span" sx={styles.text}>
                        {field.isDate && driverData[field.key] && moment(driverData[field.key]).isValid()
                          ? moment(driverData[field.key]).format('MMM YYYY')
                          : driverData[field.key]}
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Fragment>
          </Grid>
        </Grid>
        <ReasonDialog
          loading={unAssigning || loadingAssignment}
          title={`Are you sure to unassign driver ${driverData.first_name} ${driverData.last_name} [${driverData.id}] from assignment ${assigmentLabel}?`}
          open={showUnassignDriver}
          reason={reason}
          onChange={(reason) => this.setState({ reason })}
          onClose={this.hideUnassignDriver}
          onConfirm={this.confirmUnassignDriver}
          confirmText={'Unassign'}
        />
        <Box my={1}>
          <Divider />
        </Box>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ flex: 1 }}>
            <Box component="span" sx={styles.label3}>{`Vehicle Info: `}</Box>
            <Box component="span" sx={styles.showLink} onClick={() => this.setState({ showInfo: !showInfo })}>
              {!showInfo ? 'Show Info' : 'Hide Info'}
            </Box>
          </Box>
        </Box>
        {this.state.showInfo && (
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ flex: 1 }}>
                  <Box component="span" sx={styles.label}>{`MAKE:`}</Box>
                  <Box component="span" sx={styles.text}>{driverData.vehicle_make}</Box>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Box component="span" sx={styles.label}>{`MODEL:`}</Box>
                  <Box component="span" sx={styles.text}>{driverData.vehicle_model}</Box>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Box component="span" sx={styles.label}>{`COLOR:`}</Box>
                  <Box component="span" sx={styles.text}>{driverData.vehicle_color}</Box>
                </Box>
              </Box>
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ flex: 1 }}>
                  <Box component="span" sx={styles.label}>{`PLATE:`}</Box>
                  <Box component="span" sx={styles.text}>{driverData.vehicle_license_plate}</Box>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Box component="span" sx={styles.label}>{`STATE:`}</Box>
                  <Box component="span" sx={styles.text}>{driverData.vehicle_license_plate_state}</Box>
                </Box>
                <Box sx={{ flex: 1 }}></Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    );
  }
}
const DriverInfoCard = compose(inject('store'), observer)(DriverInfoCardCompose);

export default DriverInfoCard;
